module.exports = __webpack_public_path__ + "img/download-cloud-02.84cd5e93.svg";